import * as THREE from 'three';

export enum CartwheelBoneKey {
  PELVIS = 'pelvis',
  SPINE1 = 'spine1',
  SPINE2 = 'spine2',
  SPINE3 = 'spine3',
  NECK = 'neck',
  HEAD = 'head',
  LEFT_COLLAR = 'left_collar',
  LEFT_SHOULDER = 'left_shoulder',
  LEFT_ELBOW = 'left_elbow',
  LEFT_WRIST = 'left_wrist',
  RIGHT_COLLAR = 'right_collar',
  RIGHT_SHOULDER = 'right_shoulder',
  RIGHT_ELBOW = 'right_elbow',
  RIGHT_WRIST = 'right_wrist',
  LEFT_THUMB1 = 'left_thumb1',
  LEFT_THUMB2 = 'left_thumb2',
  LEFT_THUMB3 = 'left_thumb3',
  RIGHT_THUMB1 = 'right_thumb1',
  RIGHT_THUMB2 = 'right_thumb2',
  RIGHT_THUMB3 = 'right_thumb3',
  LEFT_INDEX1 = 'left_index1',
  LEFT_INDEX2 = 'left_index2',
  LEFT_INDEX3 = 'left_index3',
  RIGHT_INDEX1 = 'right_index1',
  RIGHT_INDEX2 = 'right_index2',
  RIGHT_INDEX3 = 'right_index3',
  LEFT_MIDDLE1 = 'left_middle1',
  LEFT_MIDDLE2 = 'left_middle2',
  LEFT_MIDDLE3 = 'left_middle3',
  RIGHT_MIDDLE1 = 'right_middle1',
  RIGHT_MIDDLE2 = 'right_middle2',
  RIGHT_MIDDLE3 = 'right_middle3',
  LEFT_RING1 = 'left_ring1',
  LEFT_RING2 = 'left_ring2',
  LEFT_RING3 = 'left_ring3',
  RIGHT_RING1 = 'right_ring1',
  RIGHT_RING2 = 'right_ring2',
  RIGHT_RING3 = 'right_ring3',
  LEFT_PINKY1 = 'left_pinky1',
  LEFT_PINKY2 = 'left_pinky2',
  LEFT_PINKY3 = 'left_pinky3',
  RIGHT_PINKY1 = 'right_pinky1',
  RIGHT_PINKY2 = 'right_pinky2',
  RIGHT_PINKY3 = 'right_pinky3',
  LEFT_HIP = 'left_hip',
  LEFT_KNEE = 'left_knee',
  LEFT_ANKLE = 'left_ankle',
  LEFT_FOOT = 'left_foot',
  RIGHT_ANKLE = 'right_ankle',
  RIGHT_KNEE = 'right_knee',
  RIGHT_HIP = 'right_hip',
  RIGHT_FOOT = 'right_foot',
}

export type BodyMarker = {
  name: string;
  color: string;
  markers: {
    id: CartwheelBoneKey;
    name: string;
    worldPosition: THREE.Vector3 | undefined;
    screenPosition: THREE.Vector2 | undefined;
    isDragging: boolean;
    isError: boolean;
  }[];
};

export type RetargetingBone = {
  displayName: string;
  cartwheelBoneKey: CartwheelBoneKey;
  assignedBone: THREE.Bone | null;
};

export type AssignableBone = {
  bone: THREE.Bone;
  assignedTo: CartwheelBoneKey | null;
};

export type StepData = {
  shortTitle: string;
  title: string;
  description: string;
  nextButtonText: string;
  previousButtonText: string;
};
